import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { loginUser } from '../../services/authService';
import styles from './Auth.module.css';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    try {
      const { role } = await loginUser(email, password);
      // Route based on role
      if (role === 'crmadmin') {
        navigate('/crm');
      } else {
        navigate('/user-portal');
      }
    } catch (err) {
      setError('Invalid email or password.');
      setIsLoading(false);
    }
  };

  return (
    <div className={styles.authContainer}>
      <form onSubmit={handleLogin} className={styles.authForm}>
        <h2 className={styles.title}>Welcome Back</h2>
        <p className={styles.subtitle}>Sign in to Ananta CRM</p>
        
        <input 
          type="email" 
          value={email} 
          onChange={(e) => setEmail(e.target.value)} 
          placeholder="Email Address" 
          className={styles.inputField}
          required
        />
        <input 
          type="password" 
          value={password} 
          onChange={(e) => setPassword(e.target.value)} 
          placeholder="Password" 
          className={styles.inputField}
          required
        />
        
        {error && <p className={styles.error}>{error}</p>}
        
        <button type="submit" disabled={isLoading} className={styles.submitBtn}>
          {isLoading ? 'Signing In...' : 'Login'}
        </button>
        
        <div className={styles.redirectLink}>
          Don't have an ID? <Link to="/register">Register here</Link>
        </div>
      </form>
    </div>
  );
};

export default Login;
